const cityRelayMetric = {
	"Victoria": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 57000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 20770,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				5726.0,
				7025.0,
				8019.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 63520,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				5726.0,
				7025.0,
				8019.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0,
				4750.0
			]
		}
	],
	"Chelsea": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 54600.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 22700,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				6258.0,
				7678.0,
				8764.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 63650,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				6258.0,
				7678.0,
				8764.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0,
				4550.0
			]
		}
	],
	"Mayfair": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 78000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 28423,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				7836.0,
				9614.0,
				10973.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 86923,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				7836.0,
				9614.0,
				10973.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0,
				6500.0
			]
		}
	],
	"Marylebone": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 65520.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 22517,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				6208.0,
				7616.0,
				8693.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 71657,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				6208.0,
				7616.0,
				8693.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0,
				5460.0
			]
		}
	],
	"Earl's Court": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 42000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 17054,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4702.0,
				5768.0,
				6584.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 48554,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				4702.0,
				5768.0,
				6584.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0
			]
		}
	],
	"Shepherd's Bush": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 28800.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 17284,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4765.0,
				5846.0,
				6673.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 38884,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				4765.0,
				5846.0,
				6673.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0,
				2400.0
			]
		}
	],
	"King's Cross": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 39000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 21603,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				5956.0,
				7307.0,
				8340.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 50853,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				5956.0,
				7307.0,
				8340.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		}
	],
	"Westminster": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 51000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 18584,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				5123.0,
				6286.0,
				7175.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 56834,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				5123.0,
				6286.0,
				7175.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0
			]
		}
	],
	"Notting Hill": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 44400.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 18654,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				5143.0,
				6309.0,
				7202.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 51954,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				5143.0,
				6309.0,
				7202.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0,
				3700.0
			]
		}
	],
	"Paddington": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 51000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 16409,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4524.0,
				5550.0,
				6335.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 54659,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4524.0,
				5550.0,
				6335.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0,
				4250.0
			]
		}
	],
	"Hammersmith": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 39000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 15155,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4178.0,
				5126.0,
				5851.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 44405,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				4178.0,
				5126.0,
				5851.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		}
	],
	"Kensington": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 59880.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 19428,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				5356.0,
				6571.0,
				7501.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 64338,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				5356.0,
				6571.0,
				7501.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0,
				4990.0
			]
		}
	],
	"Fulham": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 39000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 17284,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4765.0,
				5846.0,
				6673.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 46534,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				4765.0,
				5846.0,
				6673.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		}
	],
	"Covent Garden": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 56028.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 20416,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				5629.0,
				6905.0,
				7882.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 62437,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				5629.0,
				6905.0,
				7882.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0,
				4669.0
			]
		}
	],
	"Clapham": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 31800.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 17284,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4765.0,
				5846.0,
				6673.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 41134,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				4765.0,
				5846.0,
				6673.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0,
				2650.0
			]
		}
	],
	"Southwark": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 42000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 16249,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4480.0,
				5496.0,
				6273.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 47749,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				4480.0,
				5496.0,
				6273.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0,
				3500.0
			]
		}
	],
	"Shoreditch": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 39000.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 15235,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4200.0,
				5153.0,
				5882.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 44485,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				4200.0,
				5153.0,
				5882.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0,
				3250.0
			]
		}
	],
	"Canary Wharf": [
		{
			"id": "LONG_LET",
			"label": "Long let",
			"total": 35628.0,
			"borderColor": "hsl(219, 53%, 15%)",
			"data": [
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0
			]
		},
		{
			"id": "SHORT_LET",
			"label": "Short Let",
			"total": 16862,
			"borderColor": "hsl(47, 92%, 71%)",
			"data": [
				0.0,
				0.0,
				0.0,
				0.0,
				4649.0,
				5703.0,
				6510.0,
				0.0,
				0.0,
				0.0,
				0.0,
				0.0
			]
		},
		{
			"id": "FLEXIBLE_LET",
			"label": "Flexible Let",
			"total": 43583,
			"borderColor": "hsl(198, 77%, 53%)",
			"fill": true,
			"backgroundColor": "hsl(198, 77%, 73%)",
			"data": [
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				4649.0,
				5703.0,
				6510.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0,
				2969.0
			]
		}
	]
}
const listNeighbourhoods = ['Victoria', 'Chelsea', 'Mayfair', 'Marylebone', "Earl's Court", "Shepherd's Bush", "King's Cross", 'Westminster', 'Notting Hill', 'Paddington', 'Hammersmith', 'Kensington', 'Fulham', 'Covent Garden', 'Clapham', 'Southwark', 'Shoreditch', 'Canary Wharf']

export { cityRelayMetric, listNeighbourhoods }
